import { useMemo } from "react";

import { useLanguage } from "../../../../i18n/useLanguage";
import { LeadItem } from "../../../../queries/useGetDealerLeads";
import { useOrdersCriteriaParam } from "./CriteriaInput";

interface LeadsDatePredicateHook {
  (): (item: LeadItem) => boolean;
}

export const useLeadsCriteriaPredicate: LeadsDatePredicateHook = () => {
  const [criteria] = useOrdersCriteriaParam();
  const [language] = useLanguage();

  const predicate = useMemo(
    () =>
      ({
        customer,
        customerStatus,
        generatedByActionType,
        leadId,
        message,
        orderId,
        ownerType,
      }: LeadItem) => {
        const textRow: string[] = [
          customer.email,
          customer.firstName,
          customer.lastName,
          customer.phone,
          customerStatus.status,
          generatedByActionType,
          leadId,
          message,
          orderId,
          ownerType,
        ];
        return criteria.trim()
          ? textRow
              .join(" ")
              .toLowerCase()
              .includes(criteria.trim().toLowerCase())
          : true;
      },
    [criteria, language]
  );
  return predicate;
};
